import { T } from "services/lang/LanguageService";
import { ButtonType, TaskTriggerButtonProps } from "./TaskTriggerButtonTypes";

export const defaultConfig: TaskTriggerButtonProps = {
  dagId: "",
  taskId: "",
  label: T("action.run-task"),
  buttonType: ButtonType.LABEL_AND_ICON,
  tooltip: "",
  icon: "pi pi-play",
};

export const buttonTypeOptions = [
  { label: T("word.label-and-icon"), value: ButtonType.LABEL_AND_ICON },
  { label: T("word.icon-only"), value: ButtonType.ICON_ONLY },
  { label: T("word.label-only"), value: ButtonType.LABEL_ONLY },
];
